import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Small back button rendered above page titles. Prefers a `from` in
 * location.state (set by any deep link that wants a specific fallback),
 * then falls back to browser history, then to the home dashboard.
 * Hidden on the home dashboard so it never links "back to itself".
 */
export default function BackButton({ fallback = "/" }) {
  const nav = useNavigate();
  const location = useLocation();
  if (location.pathname === "/" || location.pathname === "") return null;

  function go() {
    const from = location.state && location.state.from;
    if (from && typeof from === "string" && from !== location.pathname) {
      nav(from);
      return;
    }
    if (window.history.length > 1) nav(-1);
    else nav(fallback);
  }

  return (
    <button
      type="button"
      onClick={go}
      className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition mb-4"
      data-testid="page-back-btn"
    >
      <ArrowLeft className="h-3 w-3" /> Back
    </button>
  );
}
